(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["atc-sticky-mobile"] && !Shopify.designMode) return;
  try {
    (() => {
    const sticky = document.querySelector('[data-atc-sticky]');
    const mainAtcButton = document.querySelector('[data-atc-button]');
    if (!sticky || !mainAtcButton) return;

    const position = sticky.dataset.optionPosition;
    const priceEl = sticky.querySelector('[data-sticky-price]');
    const atcButton = sticky.querySelector('[data-sticky-atc-button]');
    const atcLabel = sticky.querySelector('[data-sticky-atc-label]');
    const soldOutText = atcLabel.textContent.trim();
    let addToCartText = soldOutText;

    sticky.querySelectorAll('[data-sticky-option-value]').forEach((input) => {
      input.addEventListener('change', () => {
        const mainInput = document.querySelector(
          `[data-option-position="${position}"] [data-option-value][value="${CSS.escape(input.value)}"]`
        );
        if (mainInput) {
          mainInput.checked = true;
          mainInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    atcButton?.addEventListener('click', () => mainAtcButton.click());

    document.addEventListener('variant:change', (event) => {
      const { variant } = event.detail;

      sticky.querySelectorAll('[data-sticky-option-value]').forEach((input) => {
        input.disabled = false;
      });

      if (!variant) {
        atcButton.disabled = true;
        atcLabel.textContent = soldOutText;
        return;
      }

      if (variant.available) addToCartText = mainAtcButton.querySelector('[data-atc-label]')?.dataset.addToCartText || addToCartText;

      if (priceEl) priceEl.textContent = variant.price;
      atcButton.disabled = !variant.available;
      atcLabel.textContent = variant.available ? addToCartText : soldOutText;

      const selectedValue = variant.options[parseInt(position, 10) - 1];
      sticky.querySelectorAll('[data-sticky-option-value]').forEach((input) => {
        input.checked = input.value === selectedValue;
      });
    });

    const observer = new IntersectionObserver(
      ([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(mainAtcButton);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-chips"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-variant-picker]').forEach((root) => {
      const variantsScript = root.querySelector('[data-product-variants]');
      const idInput = root.querySelector('[data-variant-id-input]');
      const priceEl = root.querySelector('[data-price]');
      const atcButton = root.querySelector('[data-atc-button]');
      const atcLabel = root.querySelector('[data-atc-label]');
      const sizeGuideOpen = root.querySelector('[data-size-guide-open]');

      if (!variantsScript || !idInput || !atcButton) return;

      const variants = JSON.parse(variantsScript.textContent);
      const soldOutText = atcLabel.dataset.soldOutText || atcLabel.textContent;
      const addToCartText = atcLabel.dataset.addToCartText || atcLabel.textContent;

      function getSelectedOptions() {
        const options = [];
        root.querySelectorAll('[data-option-position]').forEach((group) => {
          const position = parseInt(group.dataset.optionPosition, 10);
          const checked = group.querySelector('[data-option-value]:checked');
          options[position - 1] = checked ? checked.value : undefined;
        });
        return options;
      }

      function findVariant(options) {
        return variants.find((variant) => options.every((value, index) => variant.options[index] === value));
      }

      function updateAvailability(selected) {
        root.querySelectorAll('[data-option-position]').forEach((group) => {
          const position = parseInt(group.dataset.optionPosition, 10);
          group.querySelectorAll('[data-option-value]').forEach((input) => {
            const test = [...selected];
            test[position - 1] = input.value;
            const match = variants.find((variant) =>
              test.every((value, index) => value === undefined || variant.options[index] === value)
            );
            input.disabled = !match || !match.available;
          });
        });
      }

      function update() {
        const selected = getSelectedOptions();
        const variant = findVariant(selected);

        updateAvailability(selected);

        document.dispatchEvent(
          new CustomEvent('variant:change', {
            detail: { variant, options: selected, root },
          })
        );

        if (!variant) {
          atcButton.disabled = true;
          atcLabel.textContent = soldOutText;
          return;
        }

        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price;
        atcButton.disabled = !variant.available;
        atcLabel.textContent = variant.available ? addToCartText : soldOutText;
      }

      root.querySelectorAll('[data-option-value]').forEach((input) => {
        input.addEventListener('change', update);
      });

      const form = root.querySelector('form');
      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        atcButton.disabled = true;

        try {
          const formData = new FormData(form);
          if (window.GT_CART_SECTION_ID) formData.append('sections', window.GT_CART_SECTION_ID);

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          });

          if (!response.ok) throw new Error('add-to-cart-failed');

          const result = await response.json();
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { sections: result.sections } }));
        } catch (error) {
          form.submit();
        } finally {
          atcButton.disabled = false;
        }
      });

      sizeGuideOpen?.addEventListener('click', () => {
        const drawer = document.getElementById('SizeGuideDrawer');
        if (!drawer) return;

        const selectedSize = root.querySelector('[data-size-option] [data-option-value]:checked')?.value;
        drawer.querySelectorAll('[data-size-row]').forEach((row) => {
          row.classList.toggle('is-active', row.dataset.sizeRow === selectedSize);
        });

        drawer.showModal();
      });

      update();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
